import { TransactionInterface } from '@/interfaces/TransactionInterface';
import { FC } from 'react';
import TransactionDetailList from './TransactionDetailList';
interface TransactionDetailTrayBodyContentProps {
  transaction: TransactionInterface;
}
const TransactionDetailTrayBodyContent: FC<
  TransactionDetailTrayBodyContentProps
> = ({ transaction }) => {
  return <TransactionDetailList transaction={transaction} />;
};
export default TransactionDetailTrayBodyContent;
